import { html as o } from "@microsoft/fast-element";
import { toRem as c } from "../../common/css-utils.js";
const s = (r) => {
  const t = o.partial(r.prefix);
  return o`
    <div class="control" part="control" @click="${(e) => e.subNavItemClicked()}">
      <${t}-icon name="chevron-right" size="${c(1)}">
      </${t}-icon>
      <span class="content">
      <slot></slot>
    </span>
    </div>
  `;
};
export {
  s as subNavItemTemplate
};
